import React from 'react';
import ProductModelsListing from '../productModelsListing';
 
const ProductModelListingByLine = (props): JSX.Element => {
  return (
      <ProductModelsListing {...props} />
  );
};
 
export default ProductModelListingByLine;